import React, { useState } from 'react'
import { Colors } from 'src/components/theme'
import { DarkTooltip } from 'src/components/tooltip/dark-tooltip'

type USStateProps = {
  dimensions: string
  fill: string
  label?: string
  onClick?: (e: React.MouseEvent<SVGPathElement>) => void
}

export const USState = (props: USStateProps) => {
  const { dimensions, fill, label, onClick } = props
  const [hover, setHover] = useState(false)

  const onMouseEnter = () => {
    setHover(true)
  }
  const onMouseLeave = () => {
    setHover(false)
  }

  return (
    <DarkTooltip onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} placement="right" title={label}>
      <path
        stroke-width={hover ? 4 : 1}
        stroke={hover ? Colors.neutral700 : Colors.neutral300}
        fill={fill}
        d={dimensions}
        onClick={onClick}
      />
    </DarkTooltip>
  )
}
